// @flow
// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

import type { ValueObject } from '../Types/ValuesType'
import type { ImmutableType } from '../Types/ImmutableTypes'

/* ------------- Types and Action Creators ------------- */

export type CarState = ImmutableType & {
  +data: ValueObject,
  +showPhoneValidation: boolean,
  +autoFinish: boolean,
}

const { Types, Creators } = createActions({
  carIdentificationRequestSuccess: ['data'],
  carInfoRequest: ['vin', 'autoFinish', 'endpoint', 'technicalCardNo'],
  carInfoRequestSuccess: ['data'],
  carValuationRequest: ['data', 'accessories'],
  carValuationRequestSuccess: ['id', 'valuation'],
  carWindscreenRequestSuccess: ['data'],
  onChangeValue: ['key', 'value'],
  setAutoFinish: ['autoFinish'],
  setData: ['data'],
  verificationSmsRequest: ['phone'],
  verificationSmsRequestSuccess: null,
  vinFromRzRequest: ['rz', 'autoFinish', 'endpoint'],
})

export const CarTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  // eslint-disable-line
  data: {},
  autoFinish: false,
  showPhoneValidation: false,
  windscreenPrices: null,
})

/* ------------- Reducers ------------- */

export const onChangeValueR = (state: CarState, { key, value }: { key: string, value: ValueObject }): CarState =>
  state.setIn(['data', key], value)

export const carInfoRequestR = (
  state: CarState,
  { vin, technicalCardNo }: { vin: string, technicalCardNo: string },
): CarState =>
  state
    .set('carInfo', [])
    .set('identificated', {})
    .setIn(['data', 'modalVIN'], vin)
    .setIn(['data', 'technicalCardNo'], technicalCardNo)

export const carInfoRequestSuccessR = (state: CarState, { data }: { data: Object }): CarState =>
  state.set('carInfo', data)

export const verificationSmsRequestSuccessR = (state: CarState): CarState => state.set('showPhoneValidation', true)

export const carIdentificationRequestSuccessR = (state: CarState, { data }: { data: any }): CarState =>
  state.set(
    'identificated',
    data.vehicles.reduce((acc, vehicle) => {
      acc[vehicle.administrativeData.id] = vehicle
      return acc
    }, {}),
  )

export const carValuationRequestSuccessR = (
  state: CarState,
  { id, valuation }: { id: string, valuation: any },
): CarState => state.setIn(['identificated', id, 'prices'], valuation)

export const setDataR = (state: CarState, { data }: { data: any }): CarState =>
  state.merge({ data: { ...state.data, ...data } })

const setAutoFinishR = (state: CarState, { autoFinish }: { autoFinish: boolean }): CarState =>
  state.set('autoFinish', autoFinish)

export const carWindscreenRequestSuccessR = (state: CarState, { data }: { data: any }): CarState =>
  state.set('windscreenPrices', data)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CAR_IDENTIFICATION_REQUEST_SUCCESS]: carIdentificationRequestSuccessR,
  [Types.CAR_INFO_REQUEST]: carInfoRequestR,
  [Types.CAR_INFO_REQUEST_SUCCESS]: carInfoRequestSuccessR,
  [Types.CAR_VALUATION_REQUEST]: (state) => state,
  [Types.CAR_VALUATION_REQUEST_SUCCESS]: carValuationRequestSuccessR,
  [Types.CAR_WINDSCREEN_REQUEST_SUCCESS]: carWindscreenRequestSuccessR,
  [Types.ON_CHANGE_VALUE]: onChangeValueR,
  [Types.SET_AUTO_FINISH]: setAutoFinishR,
  [Types.SET_DATA]: setDataR,
  [Types.VERIFICATION_SMS_REQUEST]: (state) => state,
  [Types.VERIFICATION_SMS_REQUEST_SUCCESS]: verificationSmsRequestSuccessR,
  [Types.VIN_FROM_RZ_REQUEST]: (state) => state,
})
